<header class="topbar">
<a routerLink="/home">
  <img src="assets/logobianco.png" alt="Profile" class="wide-banner" />
</a>
  <!-- Logo section -->
  <div class="logo">VETtrainees</div>
  
  <!-- Navigation icons for user actions 
  <nav class="nav-icons" aria-label="User actions">
   User profile button
    <button class="icon-btn" aria-label="User Profile" title="User Profile">
      <mat-icon>person</mat-icon>
      <span class="sr-only">User Profile</span>
    </button>
    
    Logout button 
    <button class="icon-btn" aria-label="Logout" title="Logout" (click)="logout()">
      <mat-icon>logout</mat-icon>
      <span class="sr-only">Logout</span>
    </button> 
  </nav> -->

  <!-- CHANGE LANGUAGE -->

  
  <div class="icon">
        <p>{{selectedLanguage.coname}}</p>
        <img src="{{selectedLanguage.urlImg}}">
        <ul>
          <li class="language-item">
            <button mat-icon-button [matMenuTriggerFor]="languageMenu" class="language-btn">
              <mat-icon>language</mat-icon>
            </button>
          </li>
        </ul>
  </div>
      
  <mat-menu #languageMenu="matMenu">
        @for (language of languages; track $index) {
          @if (selectedLanguage!=language) {
            <button mat-menu-item (click)="changeLanguage(language)" class="language-option">
              <img src="{{language.urlImg}}" class="flag-icon">
              <span>{{language.labelKey | translate}}</span>
            </button>
          }
        }
  </mat-menu>

</header>
